/**
 * A soft wash of warm light behind the page — sage and clay, barely there —
 * so large sand-coloured fields have depth without ever becoming a gradient
 * you would notice. Fixed to the viewport; pure CSS.
 */
export default function Aurora({ dim = false, className = '' }) {
  return (
    <div aria-hidden className={`pointer-events-none fixed inset-0 overflow-hidden ${className}`}
         style={{ zIndex: 0, opacity: dim ? 0.5 : 1, transition: 'opacity 1.2s' }}>
      <div className="wash-blob" style={{ width: '70vmax', height: '70vmax', left: '-25vmax', top: '-30vmax', background: 'var(--wash-a)' }} />
      <div className="wash-blob" style={{ width: '60vmax', height: '60vmax', right: '-25vmax', bottom: '-30vmax', background: 'var(--wash-b)', animationDelay: '-20s' }} />
      <div className="wash-blob" style={{ width: '40vmax', height: '40vmax', left: '35vmax', top: '30vmax', background: 'var(--wash-c)', animationDelay: '-10s', animationDuration: '55s' }} />
    </div>
  );
}
